export const LOAD_APPOINTMENTS = "LOAD_APPOINTMENTS";

export const LOAD_APPOINTMENTS_SUCCESS = "LOAD_APPOINTMENTS_SUCCESS";

export const LOAD_APPOINTMENT = "LOAD_APPOINTMENTS";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";

export const LOAD_APPOINTMENT_SUCCESS = "LOAD_APPOINTMENT_SUCCESS";

export const UPDATE_CALENDAR_SELECTED_USER_IDS = "UPDATE_CALENDAR_SELECTED_USER_IDS";
export const UPDATE_CALENDAR_SELECTED_ROOM_IDS = "UPDATE_CALENDAR_SELECTED_ROOM_IDS";

export const DELETE_APPOINTMENT_SUCCESS = "DELETE_APPOINTMENT_SUCCESS";
